import React from 'react';
import styled from 'styled-components';

import { Typo, theme } from '../../../ui';
import { ListItem } from '@mui/material';
import { TASK_TYPE } from '../../../utils/constants';

import AnswerStatusIcon from './AnswerStatusIcon';
import TeacherFeedback from './TeacherFeedback';
import { AttachmentList } from '../../../ui';

const AnswerContainer = styled.div`
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  gap:10px;
  width:100%;
`
const ListItemStyled = styled(ListItem)`
  border: 1px solid ${theme.colors.NEU_200};
  padding: 10px 0;
  margin-bottom: 10px;
`

const IconWrapper = styled.div`
  display: flex;
  padding-top: 4px;
  margin-right: 10px;
`

const UserAnswer = ({ handleOpenFeedback, answer, taskType }) => {
  const allowsFeedBack = [TASK_TYPE.OPEN, TASK_TYPE.FILE]

  return (
    <ListItemStyled component='div' alignItems="flex-start">
      <IconWrapper>
        <AnswerStatusIcon grade={answer.grade} />
      </IconWrapper>
      <AnswerContainer className='hasBorder' >
        {answer.value.map((item, index) => <Typo.Text key={answer.id + '-reply-' + index}>{item}</Typo.Text>)}
        {answer.created && <Typo.Info>{answer.created}</Typo.Info>}

        {/* only for open task answer */}
        <AttachmentList files={answer.files} />
        {allowsFeedBack.includes(taskType) && <TeacherFeedback
          key={answer.id + 'teacher-feedback'}
          feedback={answer.feedback}
          handleOpenFeedback={!!handleOpenFeedback && handleOpenFeedback}
        />}
      </AnswerContainer>
    </ListItemStyled>
  );
};

export default UserAnswer;
